export default [
  ['OverallTitle', 'OverallText'],
  ['Past7DaysTitle', 'Past7DaysText'],
  ['SelectTitle', 'SelectText'],
  [
    'OverallWinningsTitle',
    'OverallWinningsText'
  ],
  [
    'PokerWinningsTitle',
    'PokerWinningsText'
  ],
  [
    'CasinoWinningsTitle',
    'CasinoWinningsText'
  ],
  // ['Betting Winnings', 'Displays data of how many chips user won throught Betting.'],
  ['FeeAmountTitle', 'FeeAmountText']
];
